module.exports = __webpack_public_path__ + "templates/login.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/plugins/login/templates/login.html
// module id = vXDf
// module chunks = 1